import styled from "styled-components";

export const InventoryWrapper = styled.div`
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.colors.primary40};
  padding: 0 72px 100px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 0 0px 100px;
    .slick-list{
      padding: 0 50% 0 50% !important;
    }
  `}
`;
